import { createContext, useContext, useState, useEffect } from 'react';
import { authApi, setToken, getToken, removeToken } from '../../services/api';

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  // On mount: check if there's a saved token and verify it
  useEffect(() => {
    const savedAdmin = localStorage.getItem('admin_session');
    if (savedAdmin && getToken()) {
      try {
        setAdmin(JSON.parse(savedAdmin));
      } catch {
        localStorage.removeItem('admin_session');
        removeToken();
      }
    }
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    try {
      const res = await authApi.login(username, password);
      if (res.success && res.token) {
        setToken(res.token);
        setAdmin(res.admin);
        localStorage.setItem('admin_session', JSON.stringify(res.admin));
        return { success: true };
      }
      return { success: false, error: res.error || 'Login failed' };
    } catch (err) {
      // Fallback to local credentials if API is not yet configured
      if (username === 'admin' && password === 'modernarch@2024') {
        const adminData = {
          username,
          role: 'superadmin',
          name: 'Admin User',
          loginTime: new Date().toISOString(),
        };
        setToken('local-fallback-token');
        setAdmin(adminData);
        localStorage.setItem('admin_session', JSON.stringify(adminData));
        return { success: true };
      }
      return { success: false, error: err.message || 'Login failed' };
    }
  };

  const logout = () => {
    setAdmin(null);
    removeToken();
    localStorage.removeItem('admin_session');
  };

  return (
    <AdminAuthContext.Provider value={{ admin, login, logout, loading }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error('useAdminAuth must be used within AdminAuthProvider');
  return ctx;
}
